// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eEventDetailsAccessoryText {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/views/GenericView/StudentView/Events/SummaryTabs/DetailsTab/DetailsTab.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".eEventDetailsAccessoryText {\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
